import { SlateLabelEnum, ContestType } from '@betterpool/api-types/contests-service';

import type { FullContest } from '~/domains/contest/domains/services/interfaces/full-contest.interface';
import type { ContestSlate } from '~/domains/games/interfaces/contest.slates.interface';

import getIsAfterPickDeadline from '../utils/getIsAfterPickDeadline';

export type SlateWithStateAndSettingsUnknownType = {
  contestType: null;
  id: string;
  slate: ContestSlate;
  state: {
    isAfterPickDeadline: boolean;
    isGenerated: boolean;
    picksLabel?: string;
    isUpcoming?: boolean;
  };
  settings: {
    expectedPicksCount: number;
  };
  gamesCount?: number;
};

function parseSlateBase(
  contest: FullContest,
  slate: ContestSlate,
  index: number
): SlateWithStateAndSettingsUnknownType {
  const isAfterPickDeadline = getIsAfterPickDeadline(contest, slate);

  const slateName = contest?.settings.slateLabel === SlateLabelEnum.DAY
  && contest?.contest_type === ContestType.PLAYER_SURVIVOR
    ? `${contest?.settings?.slateLabel} ${index + 1}`
    : slate.name;

  return {
    contestType: null,
    id: slate.id,
    slate: {
      ...slate,
      name: slateName,
      start_date: new Date(slate.startDate),
      end_date: new Date(slate.endDate),
    },
    state: {
      isAfterPickDeadline,
      isGenerated: slate.isPicksheetAvailable,
    },
    gamesCount: slate.gamesCount,
    settings: {
      expectedPicksCount: (() => {
        const contestWideExpectedPicksCount = contest.settings.expectedPicksCount;
        const slateStepUpExpectedPicksCount = contest.settings.stepUp?.slates?.find(
          ({ slateId }) => slateId === slate.id
        )?.expectedPicksCount;
        const slateGamesCount = slate.gamesCount;
        const expectedPicksCount = slateStepUpExpectedPicksCount || contestWideExpectedPicksCount;

        return Math.min(expectedPicksCount, slateGamesCount);
      })(),
    },
  };
}

export default parseSlateBase;
